import { createSlice } from "@reduxjs/toolkit";

interface MenuTogglerState {
  isOpen: boolean;
}

const initialState: MenuTogglerState = {
  isOpen: false,
};

const menuTogglerSlice = createSlice({
  name: "menuToggler",
  initialState,
  reducers: {
    openMenu: (state) => {
      state.isOpen = true;
    },
    closeMenu: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openMenu, closeMenu } = menuTogglerSlice.actions;

export default menuTogglerSlice.reducer;
